import { BarChart3, Search, AlertCircle, User, TrendingUp } from 'lucide-react';

const pages = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'explorer', label: 'Soil Health Explorer', icon: Search },
  { id: 'advisory', label: 'Advisory & Priority', icon: AlertCircle },
  { id: 'profile', label: 'Farmer Profile', icon: User },
  { id: 'impact', label: 'Impact & Trends', icon: TrendingUp, disabled: true },
];

export function Navigation({ currentPage, onPageChange }) {
  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col py-4 gap-4">
          <div className="flex flex-col">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
              Soil Health Dashboard
            </h1>
            <p className="text-sm font-medium text-gray-500 mt-1">
              Natural Farming Program
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-6 -mb-px overflow-x-auto">
          {pages.map((page) => {
            const Icon = page.icon;
            const isActive = currentPage === page.id;
            const isDisabled = page.disabled;

            return (
              <button
                key={page.id}
                onClick={() => !isDisabled && onPageChange(page.id)}
                disabled={isDisabled}
                className={`
                  flex items-center gap-2 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                  ${isActive
                    ? 'border-[#2E7D32] text-[#2E7D32]'
                    : isDisabled
                      ? 'border-transparent text-gray-400 cursor-not-allowed'
                      : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{page.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav >
  );
}
